<template>
  <section class="user-settings-page">
    <AppHeader />
    <VdPage title="Add device" class="page" with-background show-back-arrow @back="onBack">
      <section class="device-info">
        <h2>Device info</h2>
        <DevicesForm />
      </section>
    </VdPage>
  </section>
</template>

<script lang="ts">
import { VdPage } from "@voodoo.io/voodoo-ui";
import { computed, defineComponent } from "vue";
import { RouteLocationRaw, useRouter } from "vue-router";

import AppHeader from "@/pages/Root/components/AppHeader.vue";
import links from "@/router/links";

import DevicesForm from "./components/TestDevicesForm/TestDevicesForm.vue";

export default defineComponent({
  components: {
    AppHeader,
    DevicesForm,
    VdPage,
  },
  setup() {
    const router = useRouter();
    const backLink = computed<RouteLocationRaw>(
      () => (router.options.history.state.back as string) || { name: links.games.list }
    );

    const onBack = () => {
      router.push(backLink.value);
    };

    return {
      onBack,
    };
  },
});
</script>

<style lang="scss" scoped>
.user-settings-page {
  .page {
    padding: size("L");
    box-sizing: border-box;
  }

  h2 {
    margin-bottom: size("L");
  }

  .section-description {
    margin-top: size("XL");
  }

  .device-info {
    max-width: 1000px;
    min-width: 200px;

    :deep(.vd-form) {
      .el-input__inner {
        color: var(--vd-color-grey);
      }
    }
  }
}
</style>
